import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { failed, success } from "../../../Utils/Alerts";
import axios from "axios";
import Select from "react-select";
import { _serverUrl2 } from "../../../config";
import { customFilterTool } from "../../../Utils/SelectTools";

export default function UsersUpdate() {
  const history = useHistory();
  const userID = useParams().id;

  const [roller, setRoller] = useState([]);
  const [selectedRoller, setSelectedRoller] = useState([]);
  const [isimSoyisim, setIsimSoyisimset] = useState("");
  const [telNo, setTelNo] = useState("");
  const [kullaniciAdi, setKullaniciAdi] = useState("");

  let onChangeUserRol = (e) => {
    setSelectedRoller(e);
  };

  const onClickKaydet = async () => {
    let str = "";
    selectedRoller.map((d, i) => {
      return i !== 0 ? (str = str + "," + d.value) : (str = str + "" + d.value);
    });
    let postJSON = {
      id: userID,
      isim_soyisim: isimSoyisim,
      tel_no: telNo,
      kullanici_adi: kullaniciAdi,
      rol: str,
    };
    await axios
      .post(_serverUrl2 + "/user/addUpdate", postJSON)
      .then((res) => {
        if (res.data.status) {
          success("Kullanıcı Oluşturuldu.");
          history.push("/dashboard/users");
        } else {
          failed("Kullanıcı oluşturulurken hata oluştu. " + res.data.error);
        }
      })
      .catch((err) => {
        failed("Kullanıcı oluşturulurken hata oluştu. " + err);
      });
  };

  const getInfosFromNode = useCallback(async () => {
    try {
      const rolesResponse = await axios.get(`${_serverUrl2}/user/getAllRoles`);

      if (rolesResponse.data.status) {
        const roles = rolesResponse.data.rows;
        setRoller(roles);

        if (userID !== "0") {
          const userResponse = await axios.get(`${_serverUrl2}/user/get/${userID}`);

          if (userResponse.data.status) {
            const user = userResponse.data.rows[0];
            setIsimSoyisimset(user.isim_soyisim);
            setTelNo(user.tel_no);
            setKullaniciAdi(user.kullanici_adi);

            const filteredRoles = roles.filter((r) => {
              const role = user.rol.split(",").find((roleId) => roleId == r.rol_id);
              return role ? true : false;
            });

            const selectedRoles = filteredRoles.map((role) => {
              return { label: role.rol_adi, value: role.rol_id };
            });

            setSelectedRoller(selectedRoles);
          } else {
            failed(`Veriler Getirilirken Hata Oluştu. - ${userResponse.data.error}`);
          }
        }
      } else {
        failed(`Veriler Getirilirken Hata Oluştu. - ${rolesResponse.data.error}`);
      }
    } catch (error) {
      failed(`Veriler Getirilirken Hata Oluştu. - ${error.message}`);
    }
  }, [userID]);

  useEffect(() => {
    getInfosFromNode();

    return () => {};
  }, [getInfosFromNode]);

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="textBox">
          <div className="content d-flex justify-content-between">
            <button className="orangeBtn" style={{ fontSize: "13px", width: "30px" }} onClick={() => history.goBack()}>
              <i className="fas fa-arrow-left"></i>
            </button>
            <b>{userID == 0 ? "Yeni Kullanıcı Oluştur" : "Kullanıcı Bilgilerini Düzenle"}</b>
            <b>&nbsp;</b>
          </div>
        </div>
      </div>
      <div className="col-sm-12">
        <div className="textBox" style={{ textAlign: "left", fontSize: "13px" }}>
          <div className="row">
            <div className="col-sm-4">
              <label>İsim Soyisim</label>
              <input type="text" value={isimSoyisim} onChange={(e) => setIsimSoyisimset(e.target.value)} className="form-control form-control-sm"></input>
            </div>
            <div className="col-sm-4">
              <label>Telefon Numarası</label>
              <input type="text" value={telNo} onChange={(e) => setTelNo(e.target.value)} className="form-control form-control-sm"></input>
            </div>
            <div className="col-sm-4">&nbsp;</div>
            <div className="col-sm-6">
              <label>Kullanıcı Adı</label>
              <input type="text" value={kullaniciAdi} onChange={(e) => setKullaniciAdi(e.target.value)} className="form-control form-control-sm"></input>
            </div>
            <div className="col-sm-12" style={{ marginTop: "8px" }}>
              &nbsp;
            </div>
            <div className="col-sm-12">
              <label>Kullanıcı Yetkileri</label>
              <Select
                placeholder="Seçiniz"
                isMulti
                value={selectedRoller}
                filterOption={customFilterTool}
                onChange={onChangeUserRol}
                menuPlacement={"bottom"}
                options={roller.map((d) => {
                  return { label: d.rol_adi, value: d.rol_id };
                })}
              />
            </div>
            <div className="col-sm-12" style={{ marginTop: "8px" }}>
              <table className="table table-sm table-bordered table-hover table-sm" style={{ fontSize: "11px" }}>
                <thead>
                  <tr>
                    <th>Rol Adı</th>
                    <th>Rol Tanımı</th>
                  </tr>
                </thead>
                <tbody>
                  {roller.map((d, i) => {
                    return (
                      <tr key={i}>
                        <th>{d.rol_adi}</th>
                        <td>{d.rol_aciklama}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="col-sm-4">
              <button className="darkOrangeBtn" onClick={() => history.goBack()}>
                Geri Dön
              </button>
            </div>
            <div className="col-sm-8">
              <button className="greenBtn" onClick={() => onClickKaydet()}>
                Kaydet
              </button>
            </div>
            <div className="col-sm-12">&nbsp;</div>
          </div>
        </div>
      </div>
    </div>
  );
}
